import { Container, Divider, Flex, Heading } from '@chakra-ui/react';

export default function PageMediaLibrary() {
  return (
    <>
      <Container>
        <Flex flex={1} justifyContent="space-between">
          <Heading as="h1" size="h1">
            Biblioteca de Mídia
            <span>Gerencie os arquivos da biblioteca de mídia....</span>
          </Heading>
        </Flex>
      </Container>
      
      <Divider />
      
      <Container
        flexDirection="column"
      >
        
      </Container>
    </>
  )
}
